/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { LieuFormationSelectorGridDto } from './LieuFormationSelectorGridDto';
import {
    LieuFormationSelectorGridDtoFromJSON,
    LieuFormationSelectorGridDtoFromJSONTyped,
    LieuFormationSelectorGridDtoToJSON,
} from './LieuFormationSelectorGridDto';

/**
 * 
 * @export
 * @interface LieuFormationSelectorGridDtoPaginatedResults
 */
export interface LieuFormationSelectorGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof LieuFormationSelectorGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<LieuFormationSelectorGridDto>}
     * @memberof LieuFormationSelectorGridDtoPaginatedResults
     */
    results?: Array<LieuFormationSelectorGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof LieuFormationSelectorGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the LieuFormationSelectorGridDtoPaginatedResults interface.
 */
export function instanceOfLieuFormationSelectorGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LieuFormationSelectorGridDtoPaginatedResultsFromJSON(json: any): LieuFormationSelectorGridDtoPaginatedResults {
    return LieuFormationSelectorGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function LieuFormationSelectorGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): LieuFormationSelectorGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(LieuFormationSelectorGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function LieuFormationSelectorGridDtoPaginatedResultsToJSON(value?: LieuFormationSelectorGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(LieuFormationSelectorGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

